export type ServerAvailabilityOptions = {
  fetchImpl?: typeof fetch;
  timeoutMs?: number;
};

export const checkServerAvailability = async (
  options: ServerAvailabilityOptions = {},
): Promise<boolean> => {
  if (typeof window === 'undefined') return true;
  const fetchImpl = options.fetchImpl ?? window.fetch.bind(window);
  const controller = new AbortController();
  const timeout = window.setTimeout(
    () => controller.abort(),
    Math.max(250, options.timeoutMs ?? 3_000),
  );
  try {
    const response = await fetchImpl(`/health?ts=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
      signal: controller.signal,
    });
    if (!response.ok) return false;
    const payload = await response.json().catch(() => null) as { status?: unknown } | null;
    return payload?.status === 'ok';
  } catch {
    return false;
  } finally {
    window.clearTimeout(timeout);
  }
};
